/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2025-04-29 10:47:51 */

const Keys = {
  groupRequestModuleLabel: 'groupRequestModuleLabel',
  mainLabel: 'mainLabel',
  travelDetailsInfo: 'travelDetailsInfo',
  freeTextInfo: 'freeTextInfo',
  adult: 'adult',
  child: 'child',
  ageOfChildLabel: 'ageOfChildLabel',
  ageOfChildInfo: 'ageOfChildInfo',
  adultAgeRange: 'adultAgeRange',
  childAgeRange: 'childAgeRange',
  year: 'year',
  year_plural: 'year_plural',
  age: 'age',
  button: {
    close: 'button.close',
    send: 'button.send',
    bookHere: 'button.bookHere',
    clickHere: 'button.clickHere',
    set: 'button.set'
  },
  field: {
    selectTravelDates: 'field.selectTravelDates',
    travelers: 'field.travelers'
  },
  messages: {
    error: 'messages.error',
    userNotLoggedInError: 'messages.userNotLoggedInError',
    success: 'messages.success',
    notEnoughParticipants: 'messages.notEnoughParticipants'
  }
}; export default Keys;